import {NgModule} from "@angular/core";
import {I18nConfigurationModule, I18nSharedModule, I18nConfiguration} from "@kwsoft/common-ng-i18n";
import {LanguageCode, SELECTABLE_LANGUAGE_CODES} from "../core/utilities/language-codes";

export const i18nConfiguration: I18nConfiguration = {
    defaultLanguage: LanguageCode.DE,
    languages: [...SELECTABLE_LANGUAGE_CODES],
    defaultCurrencyCode: "CHF",
    defaultCurrencyFractionDigits: 0
};

@NgModule({
    imports: [
        I18nConfigurationModule.forRoot(i18nConfiguration),
        I18nSharedModule
    ],
    exports: [I18nSharedModule]
})
export class I18nModule {
}
